import { usePageContext } from '../../../../context.js';
import { HyphenatableWordInput } from './input.word.js';
import { wrapper, container } from './organism.input-container.style.js';
import { jsx } from 'react/jsx-runtime';

function InputContainer(props) {
  const pageContext = usePageContext();
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx("div", {
      className: container,
      children: props.task.content.map((it, index) => /*#__PURE__*/jsx(HyphenatableWordInput, {
        node: it,
        taskEntryKey: props.taskEntryKey
      }, index))
    })
  });
}

export { InputContainer };
//# sourceMappingURL=organism.input-container.js.map
